import moment from 'moment';
import { atom } from 'recoil';
import { momentTz } from '../../app/components/subheader/components/DatePicker';
import { getSearchString } from '../../common/helperFunctions/getSearchString';

export const getEndingDate = (isNewDateRange?: boolean) => {
  const urlParams = getSearchString(isNewDateRange);

  return momentTz(
    urlParams.get('end') ?? moment().format('YYYY-MM-DD'), // set end date if set in url query
    urlParams.get('tz'), // set timezone if set in url query
    sameStartAndEnd(urlParams) // add almost 1 day if start and end same
  ); // default value (aka initial value)
};

function sameStartAndEnd(url: URLSearchParams) {
  return url.get('start') === url.get('end');
}

export const endingDate = atom({
  key: 'endingDate', // unique ID (with respect to other atoms/selectors)
  default: getEndingDate(),
});
